import React, { useEffect, useState } from 'react';
import Layout from 'components/Layout/Layout';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store';
import ProductItem from 'components/SearchPage/ItemsList/ProductItem/ProductItem';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import getIsLoggedIn from 'store/app/selector/getIsLoggedIn';
import OpButton from 'components/Common/op-ui-wrappers/OpButton/OpButton';
import getFavouriteProducts from 'store/favourite/selector/getFavouriteProducts';
import fetchFavouritesOperation from 'store/favourite/operation/fetchFavouritesOperation';
import toSearchResultProduct from 'utils/toSearchResultProduct';
import getFavouriteProductsCount from 'store/favourite/selector/getFavouriteProductsCount';
import NoFavourites from 'components/SearchPage/NoFavourites/NoFavourites';
import OpIcon from 'components/Common/op-ui-wrappers/OpIcon/OpIcon';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import styles from './Favorites.module.scss';

const Favorites = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);

  const numberOfFavourites = useSelector(getFavouriteProductsCount);
  const isLoggedIn = useSelector(getIsLoggedIn);
  const favourites = useSelector(getFavouriteProducts);
  const showNoFavourites = !isLoading && numberOfFavourites === 0;

  const loadFavourites = async () => {
    await dispatch(fetchFavouritesOperation());
    setIsLoading(false);
  };

  useEffect(() => {
    loadFavourites();
  }, []);

  const navigateToLoginPage = () => {
    window.location.href = '/login';
  };

  const onFavoriteClickEvent = () => {
    gtmSendEvent({
      event: 'your_favorites',
      click: 'Select the favorited item',
    });
  };

  return (
    <Layout>
      <div className={styles.header}>
        <OpText variant="headline-small-bold">{t('txt_your_favourites')}</OpText>
      </div>

      {showNoFavourites && <NoFavourites />}

      {!isLoggedIn && numberOfFavourites > 0 && (
        <div className={styles.loggedOut}>
          <OpText variant="body-large-bold" className={styles.textWithIcon}>
            <OpIcon icon="clock" />
            {t('txt_dont_lose_your_favourites')}
          </OpText>
          <OpText variant="body-large-medium">{t('txt_sign_in_to_save')}</OpText>
          <OpButton variant="primary" onClick={navigateToLoginPage} className={styles.navigateToLogin}>
            {t('txt_sign_in')}
          </OpButton>
        </div>
      )}

      <div className={styles.favoritesList}>
        {favourites.map((product, index) => (
          <div onClick={onFavoriteClickEvent}>
            <ProductItem key={product.sku} product={toSearchResultProduct(product)} index={1 + index} forceReload />
          </div>
        ))}
      </div>
    </Layout>
  );
};

export default Favorites;
